import moment from 'moment';

export default function dateToMoment(date: string) {
  // Парсим дату, которая приходит с сервера в виде нестандартной строки: May 23 2021 11:30AM
  // в Moment.js
  const [month, day, year, time] = date.split(/\s+/);
  const formattedDate = [day, month, year, time.slice(0, -2), time.slice(-2)].join(' ');
  return moment(formattedDate);
}
